import React from "react";

// Нуурын давалгааны давхаргууд (арынхаас урагш). Долгионы урт нь 1440-д хуваагддаг тул
// 1440-өөр шилжүүлэхэд (.lake-drift) залгаасгүй тасралтгүй урсана.
const W = 1440;
const LAYERS = [
  { y: 34, amp: 10, len: 360, dur: 26, reverse: false },
  { y: 54, amp: 9, len: 240, dur: 19, reverse: true },
  { y: 74, amp: 7, len: 480, dur: 32, reverse: false },
];

// y суурьтай, amp далайцтай, len урттай давалгааг 2×W өргөнд зураад доод талыг дүүргэнэ
const wavePath = ({ y, amp, len }) => {
  let d = `M0 ${y} Q${len / 4} ${y - amp} ${len / 2} ${y}`;
  for (let x = len / 2; x < W * 2; x += len / 2) d += ` T${x + len / 2} ${y}`;
  return `${d} V120 H0Z`;
};

/**
 * Хөвсгөл нуурын давалгаа — хэсгүүдийн ирмэг (hero-гийн доод, footer-ийн дээд, бараан хавтан).
 * layers: давхарга бүрийн fill-* класс (арынхаас урагш). 2 өгвөл урд талын 2 давалгааг зурна.
 * prefers-reduced-motion үед хөдөлгөөнгүй.
 */
const LakeWaves = ({ layers = [], className = "", animate = true }) => (
  <svg
    viewBox={`0 0 ${W} 120`}
    preserveAspectRatio="none"
    aria-hidden="true"
    className={`block w-full overflow-hidden pointer-events-none ${className}`}
  >
    {layers.map((fill, i) => {
      const layer = LAYERS[LAYERS.length - layers.length + i];
      return (
        <path
          key={i}
          d={wavePath(layer)}
          className={`${fill} ${animate ? "lake-drift" : ""}`}
          style={
            animate
              ? { animationDuration: `${layer.dur}s`, animationDirection: layer.reverse ? "reverse" : "normal" }
              : undefined
          }
        />
      );
    })}
  </svg>
);

export default LakeWaves;
